"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectRequestFallback = void 0;
exports.instanceOfDirectRequestFallback = instanceOfDirectRequestFallback;
exports.DirectRequestFallbackFromJSON = DirectRequestFallbackFromJSON;
exports.DirectRequestFallbackFromJSONTyped = DirectRequestFallbackFromJSONTyped;
exports.DirectRequestFallbackToJSON = DirectRequestFallbackToJSON;
exports.DirectRequestFallbackToJSONTyped = DirectRequestFallbackToJSONTyped;
/**
 * When set, this shift was posted as a direct request to a specific nurse. Value is the fallback policy if the nurse declines: CANCEL_SHIFT or OPEN_TO_NETWORK.
 * @export
 */
exports.DirectRequestFallback = {
    CancelShift: 'CANCEL_SHIFT',
    OpenToNetwork: 'OPEN_TO_NETWORK'
};
function instanceOfDirectRequestFallback(value) {
    for (const key in exports.DirectRequestFallback) {
        if (Object.prototype.hasOwnProperty.call(exports.DirectRequestFallback, key)) {
            if (exports.DirectRequestFallback[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function DirectRequestFallbackFromJSON(json) {
    return DirectRequestFallbackFromJSONTyped(json, false);
}
function DirectRequestFallbackFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DirectRequestFallbackToJSON(value) {
    return value;
}
function DirectRequestFallbackToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=DirectRequestFallback.js.map